import { cn } from "@/lib/utils";
import { TONES, usageTone } from "@/lib/status";

// Barra de utilização compacta com cor por limiar.
export const UsageBar = ({ value, max, unit = "", label, pct: pctProp, className, showValue = true }) => {
  const pct = pctProp != null ? pctProp : max ? Math.round((value / max) * 100) : value;
  const tone = TONES[usageTone(pct)];
  return (
    <div className={cn("space-y-1", className)}>
      {(label || showValue) && (
        <div className="flex items-center justify-between text-xs">
          {label && <span className="text-muted-foreground">{label}</span>}
          {showValue && (
            <span className="font-mono text-foreground/90">
              {max != null ? `${value} / ${max}${unit ? " " + unit : ""}` : `${pct}%`}
            </span>
          )}
        </div>
      )}
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-white/5">
        <div className={cn("h-full rounded-full transition-all duration-500", tone.dot)} style={{ width: `${Math.min(100, pct)}%` }} />
      </div>
    </div>
  );
};

// Linha rótulo + barra (CPU / RAM / Disco) usada em cards e detail.
export const ResourceStatus = ({ label, value, max, unit, pct, compact = false }) => {
  const known = pct != null || value != null && (max != null || value != null);
  const percent = known ? (pct != null ? pct : max ? Math.round((value / max) * 100) : value) : 0;
  const tone = TONES[usageTone(percent)];
  return (
    <div className="grid grid-cols-[52px_1fr_auto] items-center gap-3">
      <span className="text-[11px] font-medium uppercase tracking-wider text-muted-foreground">{label}</span>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-white/5">
        <div className={cn("h-full rounded-full transition-all duration-500", tone.dot)} style={{ width: `${known ? Math.min(100, percent) : 0}%` }} />
      </div>
      <span className="min-w-[76px] text-right font-mono text-xs text-foreground/90">
        {known ? (max != null ? `${value} / ${max}${unit ? " " + unit : ""}` : `${percent}%`) : "—"}
      </span>
    </div>
  );
};
